module.exports = __webpack_public_path__ + "img/banner-big.e11df61b.png";